import {
  ALL_SESSION_VLANS_VALUE,
  getTrunkedNetworkUidsFromNic,
} from '../../../../../../Configure/Utils';

export function getTrunkedNetworkDisplayNames(
  networks: Network[] | undefined,
  allSessionVlansLabel: string,
  trunk?: TrunkedNetworkInterface,
): string[] {
  if (!trunk) {
    return [];
  }

  const selection = getTrunkedNetworkUidsFromNic({ trunk });

  if (selection.includes(ALL_SESSION_VLANS_VALUE)) {
    return [allSessionVlansLabel];
  }

  return selection.map((uid) => {
    const network = networks?.find((network) => network.uid === uid);
    const trunkedNetwork = trunk.networks?.find((network) => network.uid === uid);
    return network?.name ?? trunkedNetwork?.name ?? uid;
  });
}
